import React from 'react';
import { Form, Row, Col, InputGroup, Button, ButtonGroup, IconButton } from '../ui-kit';
import { IconEye, IconEyeSlash, IconTrash, IconCog, IconCircleNotch } from '../ui-kit/icons';

const WidgetHeader = ({
  editMode,
  id,
  title,
  updateWidgetTitle,
  showHeader,
  toggleShowHeader,
  toggleAutoScroll,
  autoScrollEnabled,
  removeWidget,
  setShowWidgetSettings,
  SettingsTagName
}) => {
  if (!editMode && !title) return;
  if (!editMode) return <div className="ms-2 text-uppercase small fw-semibold text-muted">{title}</div>;

  return (
    <Row className="g-2">
      <Col>
        <InputGroup>
          <Form.Control value={title} onChange={e => updateWidgetTitle(id, e.target.value)} />
          <Button
            active={showHeader}
            variant="outline-secondary"
            title={I18n.t('dashboards.pin_header')}
            onClick={toggleShowHeader}
          >
            {showHeader ? <IconEye fixedWidth /> : <IconEyeSlash fixedWidth />}
          </Button>
        </InputGroup>
      </Col>
      <Col sm="auto" className="text-end">
        <ButtonGroup>
          <IconButton
            onClick={toggleAutoScroll}
            title={I18n.t('dashboards.autoscroll')}
            Icon={IconCircleNotch}
            spin={autoScrollEnabled}
          />
          {SettingsTagName && <IconButton onClick={() => setShowWidgetSettings(true)} Icon={IconCog} />}
          <IconButton onClick={() => removeWidget(id)} Icon={IconTrash} />
        </ButtonGroup>
      </Col>
    </Row>
  );
};

export default WidgetHeader;
